import { RouteRecordRaw } from 'vue-router';
import { RouteMetaType, ExtendedRouteMetaType } from '@router/routes/types';
import { ENTRY_POINTS } from '@constants/entry-points';

type UserAppRouteMetaType = RouteMetaType & {
  requiresAuth: true;
  requiresTenant: false;
  requiresTenantAdmin: false;
  requiresEnterpriseLicense: false;
};

const META_DEFAULT: UserAppRouteMetaType = Object.freeze({
  requiresAuth: true,
  requiresTenant: false,
  requiresTenantAdmin: false,
  requiresEnterpriseLicense: false,
  redirectOnError: ENTRY_POINTS.PATH.UNAUTHORIZED(),
});

const getMeta = (
  extendedMeta: ExtendedRouteMetaType<UserAppRouteMetaType> = {},
): UserAppRouteMetaType => ({ ...META_DEFAULT, ...extendedMeta });

const routes: Array<RouteRecordRaw> = [
  {
    path: '/user',
    component: () => import('@views/user-app/UserRootView.vue'),
    redirect: ENTRY_POINTS.PATH.USER_HOME(),
    meta: getMeta(),
    children: [
      {
        path: 'dashboard',
        name: ENTRY_POINTS.PATH.USER_HOME().name,
        component: () => import('@views/user-app/UserHomeView.vue'),
        meta: getMeta({ title: 'Home' }),
      },
      {
        path: 'settings',
        name: ENTRY_POINTS.PATH.USER_APP_SETTINGS().name,
        component: () => import('@views/user-app/SettingsView.vue'),
        meta: getMeta({ title: 'Settings' }),
      },
    ],
  },
];

export default routes;
